export default __webpack_public_path__ + "static/media/CA-4 Filled app details.dfb81f3a.png";